import { Button, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../utils/ErrorModal";

const VendorDetails = () => {
  const [details, setDetails] = useState();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [errors, setErrors] = useState({})
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState()
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const updatedValue =
      e.target.name === "pan" ? e.target.value.toUpperCase() : e.target.value;
    setDetails({ ...details, [e.target.name]: updatedValue });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = details || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (isEmpty(data.name)) newErrors.name = "Name is required";
    if (isEmpty(data.firmName)) newErrors.firmName = "Firm Name is required";

    if (isEmpty(data.pan)) {
      newErrors.pan = "PAN is required";
    } else if (!panRegex.test(data.pan)) {
      newErrors.pan = "Invalid PAN format (e.g. ABCDE1234F)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/vendor/details`,
        {
          email: storedUser.username,
          name: details.name,
          firmName: details.firmName,
          pan: details.pan,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate("/vendor/dashboard");
    } catch (error) {
      setOpen(true);
      setMsg(error.response.data.Exception || "Internal server error")
    } finally {
      setLoading(false)
    }
  };
  return (
    <div className="App" style={{postion: 'relative'}}>
      {loading && <div className="loading-div"></div>}
      <div className="border-container">
        <Typography variant="h4" textAlign={"center"} mb={5}>
          Enter Your Details
        </Typography>
        <form>
          <Grid2 container columnSpacing={4}>
            <Grid2 size={{ xs: 12, sm: 12 }}>
              <label htmlFor="name">Your Name</label>
              <input
              className={`${errors.name && "input-error"}`}
                type="text"
                name="name"
                id="name"
                onChange={handleChange}
              />
              {errors.name && <p className="error">{errors.name}</p> }
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12 }}>
              <label htmlFor="firmName">Your Firm Name</label>
              <input
              className={`${errors.firmName && "input-error"}`}
                type="text"
                name="firmName"
                id="firmName"
                onChange={handleChange}
              />
              {errors.firmName && <p className="error">{errors.firmName}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12 }}>
              <label htmlFor="pan">PAN</label>
              <input 
              className={`${errors.pan && "input-error"}`}
              type="text" name="pan" id="pan" onChange={handleChange} />
              {errors.pan && <p className="error">{errors.pan}</p>}
            </Grid2>
          </Grid2>
          <Button className="btn-contained" fullWidth onClick={handleSubmit}>
            Save
          </Button>
        </form>
      </div>
      <ErrorModal open={open} handleClose={() => setOpen(false)} msg={msg} />
    </div>
  );
};

export default VendorDetails;